<template>
  <v-app v-if="!isOpera" class="white brand-typography">
    <v-navigation-drawer
            floating
            fixed
            style="border-bottom-right-radius: 10px"
            :mini-variant="miniVariant"
            :clipped="clipped"
            class="elevation-5 pt-3"
            height="auto"
            v-model="drawer"
            app

    >
      <v-layout column wrap>
        <v-flex xs12>
          <v-list  class="pt-0">
            <v-list-tile
                    v-for="item in navigationDrawerItems"
                    :key="item.title"
                    @click=""
                    active-class="primary--text"
                    :to="item.link"
            >
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>

        <v-flex xs12 style="height: auto" class="primary" v-show="!isAdmin">
          <v-container>
            <v-layout align-end justify-center row fill-height>
              <v-flex xs12 class="text-xs-center pa-1">
                <v-card-media src="/static/svgImages/farmer vector.svg" height="150px" contain></v-card-media>
                <h2 class="white--text display-2">{{producers.length}}</h2>
                <span class="white--text" style="font-size: 22px">Producteurs</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

      </v-layout>


    </v-navigation-drawer>
    <v-toolbar
            fixed app :clipped-left="clipped" class="white pa-1"
    >
      <v-toolbar-side-icon class="hidden-sm-and-up" v-show="!isNotIndex" @click="drawer = !drawer"></v-toolbar-side-icon>

        <v-toolbar-title class="mt-4 hidden-sm-and-down" >
            <router-link to="/" tag="h3" style="cursor: pointer">
                <v-avatar
                        size="36px">
                    <img
                            src="https://firebasestorage.googleapis.com/v0/b/ligablofoods.appspot.com/o/logo%2FlogoLigabloFood.png?alt=media&token=7f73a57c-db33-472a-9a1f-dccfc96ebb69"
                            alt="Avatar"
                    >
                </v-avatar>
              <span class="primary--text">Ligablo</span> Food<v-chip>BETA</v-chip>
            </router-link>
          <br>
        </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
              v-show="drawer"
              solo
              append-icon="search"
              label="Recherche"
              v-model="search"
      >
      </v-text-field>
      <v-spacer></v-spacer>
      <v-btn flat class="primary--text" v-for="(item, index) in items2" :key="index" :to="item.link" v-show="isNotIndex"><b>{{item.title}}</b></v-btn>
      <v-btn large dark class="primary hidden-sm-and-up" v-show="!isLoggedIn" to="/connexion" icon><v-icon large>person</v-icon></v-btn>
      <v-menu bottom left v-if="isLoggedIn">
            <span slot="activator" class="pa-1"><b>{{userDetails.names}}</b>
            <v-icon>arrow_drop_down</v-icon>
            </span>
            <v-list>
                <v-list-tile
                        @click=""
                >
                    <v-list-tile-title>Profil</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                        @click="signOut"
                >
                    <v-list-tile-title>Deconnexion</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
      <v-btn large dark class="primary hidden-sm-and-down" to="/connexion" v-else><v-icon left>person</v-icon><b>Se connecter</b></v-btn>
      <v-btn large dark class="primary--text" icon to="/notifications"><v-icon medium>notifications_none</v-icon></v-btn>
        <v-badge overlap color="orange" style="cursor: pointer">
            <span v-if="!isShoppingCartEmpty" @click="openShoppingCart" slot="badge">{{totalShoppingCartItem}}</span>
            <v-icon to="panier" @click="openShoppingCart" medium class="primary--text">shopping_cart</v-icon>
        </v-badge>

    </v-toolbar>
    <v-content class="">
      <router-view/>
    </v-content>
    <v-footer :fixed="fixed" style="margin-top: 100px" class="primary">
            <v-layout row wrap class="white--text primary">
                <v-flex xs12>
                    <v-container>
                        <v-layout row wrap>
                            <v-flex xs12 md4>
                                <p style="font-size: 16px">ligablofood@gmail.com</p>
                                <p style="font-size: 16px">+243 (0) 814 076 381 | 853 397 653</p>
                            </v-flex>
                            <v-flex xs12 md4 class="text-xs-center">
                                <p style="font-size: 16px">
                                    ©2018, Ligablo Food.
                                </p>

                            </v-flex>
                            <v-flex xs12 md4 class="text-xs-right">
                                <p>
                                    <v-btn icon dark>
                                        <v-icon large>fa-twitter</v-icon>
                                    </v-btn>
                                </p>

                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-flex>

            </v-layout>
    </v-footer>
  </v-app>
  <v-app v-else class="white brand-typography">
    <v-content>
      <v-container grid-list-md fill-height>
        <v-layout row wrap align-center justify-center>
          <v-flex xs12 md5 class="text-xs-center primary" style="padding: 50px; border-radius: 10px">
            <h2 class="white--text">Veillez utiliser un autre navigateur que Opera mini</h2>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
import './assets/style/vuetify-import.css'
import { detect } from 'detect-browser'
import firebase from 'firebase/app'
import 'firebase/firestore'

const browser = detect()
export default {
  watch: {
    '$route' (to, from) {
      if (this.$route.name === 'Connexion' || this.$route.name === 'Equipe' || this.$route.name === 'Apropos' || this.$route.name === 'Inscription') {
        this.drawer = false
      } else {
        this.drawer = true
      }
    }
  },
  created () {
    if (this.$route.name !== 'Index' || this.$route.name !== 'Connexion') {
      this.drawer = false
    }
    this.$store.dispatch('initRealTimeProducersListeners')
  },
  computed: {
    producers () {
      return this.$store.state.producers
    },
    navigationDrawerItems () {
      let navigationDrawerItems = []
      if (this.isLoggedIn && this.userDetails.role === 'acheteur') {
        navigationDrawerItems = [
          { title: 'Explorer', icon: 'home', link: '/' },
          { title: 'Producteurs', icon: 'supervisor_account', link: '/producteurs' },
          { title: 'Catalogue', icon: 'store', link: '/catalogue' },
          { title: 'Mes commandes', icon: 'store', link: '/commandes' }
        ]
      } else if (this.isLoggedIn && this.userDetails.role === 'producteur') {
        navigationDrawerItems = [
          { title: 'Mes produits', icon: 'home', link: '/mes-produits' },
          { title: 'Mes ventes', icon: 'store', link: '/mes-ventes' }
        ]
      } else if (this.isLoggedIn && this.userDetails.role === 'administrateur') {
        navigationDrawerItems = [
          { title: 'Acceuil', icon: 'home', link: '/console/admin/dashboard' },
          { title: 'Producteurs', icon: 'supervisor_account', link: '/producteurs' },
          { title: 'Produits', icon: 'store', link: '/produits' },
          { title: 'Commandes', icon: 'store', link: '/commandes' }
        ]
      } else {
        navigationDrawerItems = [
          { title: 'Explorer', icon: 'home', link: '/' },
          { title: 'Producteurs', icon: 'supervisor_account', link: '/producteurs' },
          { title: 'Catalogue', icon: 'store', link: '/catalogue' }
        ]
      }
      return navigationDrawerItems
    },
    isCongo () {
      return this.$route.name === 'Congo'
    },
    isConnexion () {
      return this.$route.name === 'Connexion' || this.$store.getters.user !== null || this.$store.getters.user !== undefined
    },
    isLoggedIn () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userDetails () {
      return this.$store.getters.user
    },
    isNotIndex () {
      return this.$route.name === 'Apropos' || this.$route.name === 'Equipe'
    },
    isOpera () {
      return browser.name === 'opera'
    },
    totalShoppingCartItem () {
      return this.$store.state.shoppingCart.length
    },
    isShoppingCartEmpty () {
      return this.$store.state.shoppingCart.length === 0
    },
    isAdmin () {
      return this.isLoggedIn && this.userDetails.role === 'administrateur'
    }
  },
  data () {
    return {
      clipped: true,
      fixed: false,
      drawer: true,
      items2: [
        { title: 'à propos', icon: 'home', link: '/apropos' },
        // { title: 'Notre marché', icon: 'supervisor_account', link: '/marché' },
        //        { title: 'Histoire', icon: 'store', link: '/histoire' },
        { title: 'équipe', icon: 'store', link: '/équipe' }
      ],
      items: [
        { title: 'Acceuil', icon: 'home', link: '/accueil' },
        { title: 'Producteurs', icon: 'supervisor_account', link: '/producteurs' },
        { title: 'Produits', icon: 'store', link: '/produits' }
      ],
      right: null,
      miniVariant: false,
      rightDrawer: false,
      title: ''
    }
  },
  methods: {
    signOut () {
      this.$store.dispatch('SIGN_OUT')
    },
    openShoppingCart () {
      this.$router.push('/panier')
    }
  },
  beforeMount: function () {
    const db = firebase.firestore()
    db.collection('deployment').doc('new-deployment').onSnapshot(function (doc) {
      let serverVersion = doc.data().version
      let localVersion = JSON.parse(localStorage.getItem('version'))
      console.log('beforeMount')
      if (localVersion === null || localVersion === undefined) {
        localStorage.setItem('version', JSON.stringify(serverVersion))
        window.location.reload(true)
      }

      if (localVersion !== serverVersion) {
        localStorage.setItem('version', JSON.stringify(serverVersion))
        window.location.reload(true)
      } else {
      }
    })
  },
  name: 'App'
}
</script>
<style scoped>
  #my-btn{
    color: #00c3b5;
  }
  @font-face {
    font-family: "Product Sans";
    src: url("/static/fonts/Product_Sans.ttf");
  }
  @font-face {
      font-family: "Great Vibes";
      src: url("/static/fonts/GreatVibes-Regular.ttf")
  }
  .brand-typography {
    font-family: "Product Sans",'Poppins', serif;
  }
  .style-icon {
    font-family: "Great Vibes", Serif
  }
  @import "../node_modules/font-awesome/css/font-awesome.css";

</style>



// WEBPACK FOOTER //
// src/App.vue